import React, {useState, useRef, useContext} from 'react'
import { QlikUIContext } from '../../QlikUIContext'
import { DialogModal } from '../DialogModal'
import { Script } from '../Script'
import { Style }  from '../Style'
import styles from './css/wrapper-mvc-reports-app.css'

export const DashboardConfig = ({config, onEndPersonalization, onDeleteReport }) => {

    const [showModal, setShowModal] = useState(false);
    const [configModal, setConfigModal] = useState(null);

    const context = useContext(QlikUIContext);
    const appRoot = useRef();

    const onClosingModal = () => {

        if (appRoot.current.attributes.pendingchangesflag.nodeValue === '1') {

            setConfigModal({
                title: 'Información',
                text: 'Tiene cambios sin guardar. ¿Desea salir de todos modos?',
                show: true,
                onAccept: () => {
                    setConfigModal(null);
                    setShowModal(false);
                    onEndPersonalization();
                },
                onCancel: () => {
                    setConfigModal(null);
                    setShowModal(false);
                }
            });
            setShowModal(true);
        }
        else {
            onEndPersonalization();
        }
    }

    const onDeletingReport = () => {

        setConfigModal({
            title: 'Información',
            text: config.reportType === '0' ? 'Se va a proceder a la eliminación del cuadro de mando. ¿Desea continuar?' 
                : 'Se va a proceder a la eliminación del informe. ¿Desea continuar?',
            show: true,
            onAccept: () => {
                setConfigModal(null);
                setShowModal(false);
                onDeleteReport();
            },
            onCancel: () => {
                setConfigModal(null);
                setShowModal(false);
            }
        });
        setShowModal(true);
    }

    return (
        <React.Fragment>
 
            <Style src={context.bootstrapCssPath} />
            <Style src={context.fontAwesomeCssPath} />
                       
            <Script src={`${context.dashboardConfigPath}runtime.js`} async={false} />
            <Script src={`${context.dashboardConfigPath}polyfills.js`} async={false} />
            <Script src={`${context.dashboardConfigPath}main.js`} async={false} />
            <Style src={`${context.dashboardConfigPath}styles.css`} />

            <Style src={`${context.dashboardConfigPath}hack-mvc-reports-app.css`} />

            <div id="report-editor" className={styles.report_editor}>
                <div className={styles.report_editor__actions}>
                    <div></div>
                    <div>
                        <span>Agregue, ancle, mueva y cambie el tamaño de sus elementos.</span>&nbsp;
                        <button id="btnCloseReportEditor" className="btn btn-success btn-sm" 
                            onClick={onClosingModal}
                        >Personalización finalizada</button>
                    </div>
                    <div className={styles.report_editor__action_delete}>
                        <button id="btnDeleteReport" className={`btn btn-sm ${config.editorMode === '0' ? 'hide' : ''}`} title="Eliminar"
                            onClick={onDeletingReport}
                        >
                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>

                <div className={styles.report_editor__content}>
                    <app-root ref={appRoot} id="reportEditorApp" 
                        user-name={context.userName} 
                        dash-type={config.reportType} 
                        dash-name={config.activeReportName} 
                        ambit-id={config.ambitId}
                        stream-id={config.streamId} 
                        security-token={`Bearer ${context.securityToken}`} 
                        subscription={context.subscription}  
                        api-endpoint={context.reportsQlikApiEndpoint}
                        editor-mode={config.editorMode} 
                        roles={context.roles} pendingChangesFlag="0"></app-root>
                </div>
            </div>

            {showModal && configModal !== null && <DialogModal config={configModal} />}

            <input type='hidden' id="ApiEndpoint" value={context.reportsQlikApiEndpoint} ></input>
            <input type='hidden' id="Subscription" value={context.subscription} ></input>
            <input type='hidden' id="SecurityToken" value={context.token} ></input>
            <input type='hidden' id="ReturnUrl" value='' ></input>
            <input type='hidden' id="EditorMode" value={config.editorMode} ></input>

            <input type="hidden" id="Report" value={JSON.stringify(config.report)}></input>
        </React.Fragment>
    );
}